import { normalizePhoneNumber } from './phone-number.util';

export type PasswordStrength = 'weak' | 'medium' | 'strong' | '';

export const ALLOWED_EMAIL_DOMAINS: readonly string[] = [
  '@bsdenterprise.com',
  '@aeroservfbo.com',
  '@gmail.com',
];

export interface RegisterFormValue {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  phoneNumber: string;
}

export function getPasswordStrength(password: string): PasswordStrength {
  if (!password) return '';

  const strong =
    password.length >= 8 &&
    /\d/.test(password) &&
    /[!@#$%^&*(),.?":{}|<>]/.test(password) &&
    /[a-z]/.test(password) &&
    /[A-Z]/.test(password);

  const medium = password.length >= 8 && (/\d/.test(password) || /[!@#$%^&*]/.test(password));

  return strong ? 'strong' : medium ? 'medium' : 'weak';
}

export function isEmailDomainAllowed(
  email: string,
  domains: readonly string[] = ALLOWED_EMAIL_DOMAINS
): boolean {
  const trimmed = email?.trim() ?? '';
  if (!trimmed.includes('@')) return false;

  const domain = ('@' + trimmed.split('@')[1]).toLowerCase();
  return domains.some(allowedDomain => domain === allowedDomain.toLowerCase());
}

/** Devuelve el primer error del formulario de registro, o '' si es válido. */
export function validateRegisterForm(form: RegisterFormValue): string {
  if (!form.firstName.trim() || !form.lastName.trim() || !form.email.trim() || !form.password) {
    return 'Completa todos los campos';
  }

  if (!isEmailDomainAllowed(form.email)) {
    return `Solo se permiten cuentas con los siguientes dominios: ${ALLOWED_EMAIL_DOMAINS.join(', ')}`;
  }

  if (form.password !== form.confirmPassword) {
    return 'Las contraseñas no coinciden';
  }

  if (getPasswordStrength(form.password) === 'weak') {
    return 'La contraseña es muy débil';
  }

  if (form.phoneNumber.trim() && !normalizePhoneNumber(form.phoneNumber).startsWith('+')) {
    return 'Ingresa el teléfono con clave de país o con 10 dígitos.';
  }

  return '';
}
